import { PlanHint } from '../types';
import {api} from './api';

export const planHintsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planHintCreate: builder.mutation({
			query: (planHint: Partial<Omit<PlanHint, 'id'>>) => ({
				url: 'planHints',
				method: 'POST',
				body: planHint,
			}),
		}),
	}),
});

export const {usePlanHintCreateMutation} = planHintsApi;
